import React from "react";

import Connection from "./Connection";

import { TbPlugConnectedX } from "react-icons/tb";
import {connect} from "react-redux";
const ConnectionList = ({data}) => {

    const _minWidth = 200

    const _height = window.innerHeight - 150

    const empty = data && data.length === 0 // data.filter(it => it.connected).length === 0

    return (
        <div key={'llll'}>
            <div className="list listHeader" key={'header_'} style={{
                minWidth: _minWidth,
            }}>
                <span key={'conx12'}><TbPlugConnectedX/>&nbsp;Connections</span>
            </div>

            <div key={'connecte_'} className="list listBody" style={{
                minWidth: _minWidth,
                height: _height,
                overflowY: 'auto',
            }}>
                {data && data.map(it =>
                    /*it && it.connected ? <Connection key={it.uid+"_con"} data={it}/> : null*/
                    <Connection key={it.uid+"_con"} uid={it.uid} show={true} data={it} is_node={true}/>
                )}
            </div>
        </div>
    )
}

function mapStateToProps(state, other) {

    return {data: state.bidib.data.node.filter(it => (it.connected === true && it.onconnection === true))}
    //return {data: state.bidib.data.node.filter(it => (it.deleted === undefined ? true : !it.deleted) && it.connected && (it.onconnection || it.linkrole === 1 ))  }
}

export default connect(mapStateToProps)(ConnectionList)